import { DocumentTypeEnum } from '../../enums/EnumsValues';
import FileUploader from './FileUploader/FileUploader';
import { useState } from 'react';

const useFileUploader = (documentType?: DocumentTypeEnum) => {
  const [documentUploaded, setDocumentUploaded] = useState<boolean>(false);

  const notifyDocumentUploaded = () => {
    setDocumentUploaded(true);
  };

  return {
    FileUploader: () => (
      <FileUploader
        documentType={documentType}
        onDocumentUploaded={notifyDocumentUploaded}
      />
    ),
    documentUploaded,
    notifyDocumentUploaded,
  };
};

export default useFileUploader;
